
import {
    computed,
    defineComponent,
    ref,
} from 'vue';

export const regexpHelpLink = 'https://regexpal.com';

export default defineComponent({
    name: 'RegExpInput',
    props: {
        hint: { type: [ String, Boolean ], required: false, default: false },
        assumeAnchors: { type: Boolean, required: false, default: true },
        placeholder: { type: String, required: false, default: '.*' },
        persistentHint: { type: Boolean, required: false, default: false },
    },
    setup (props, { emit }) {
        const inputErr = ref<Error | null>(null);
        return {
            useDefaultHint: computed(() => props.hint === false || !inputErr.value),
            inputErr,
            hovering: ref(false),
            setRegExp (event: string, v = '') {
                inputErr.value = null;
                try {
                    // eslint-disable-next-line no-new
                    new RegExp(v, 'u');
                    emit(event, v);
                } catch (err) {
                    inputErr.value = err;
                }
            },
            regexpHelpLink,
        };
    },
});
